export default async function usePagination({
  apiOptions,
}: {
  apiOptions?: MaybeRefOrGetter<FetchAPIOptions>
}) {
  const { y } = useWindowScroll()
  const route = useRoute()
  const itemsPerPage = ref(30)

  const pagesTotal = computed(() =>
    calculateTotalPages(totalItems.value, itemsPerPage.value),
  )
  const hasPages = computed(() => pagesTotal.value > 1)
  const currentPage = computed(() => parseInt(route.query.page as string) || 1)
  const paginationQuery = computed(() => ({
    per_page: itemsPerPage.value,
    page: currentPage.value,
  }))

  function calculateTotalPages(totalItems, itemsPerPage) {
    return Math.ceil(parseInt(totalItems) / parseInt(itemsPerPage)) || 0
  }

  function validatePage(currentPage = '1', totalPages = '1') {
    const page = parseInt(currentPage)
    const total = parseInt(totalPages)
    if (page < 1 || page > total) {
      setPage(1)
    }
  }

  async function setPage(page) {
    await navigateTo({
      path: route.path,
      query: { ...route.query, page },
    })
    y.value = 0
  }

  const updatedApiOptions = computed(() => ({
    ...toValue(apiOptions),
    per_page: itemsPerPage.value,
    page: currentPage.value,
    ...paginationQuery.value,
  }))

  const { data, error, refresh, status } =
    await useStoryblokHelpers().fetchAsyncData('stories', updatedApiOptions, {
      watch: [currentPage, () => toValue(apiOptions)],
    })
  const stories = computed(() => data?.value?.data?.stories || [])
  const totalItems = computed(() => parseInt(data?.value?.headers.total || 0))

  return {
    totalItems,
    itemsPerPage,
    pagesTotal,
    hasPages,
    currentPage,
    paginationQuery,
    validatePage,
    setPage,
    stories,
    refresh,
    error,
    status,
    calculateTotalPages,
  }
}
